/**
 * Ad Stack Configuration
 *
 * Publift Fuse handles GAM, Prebid header bidding, and 50+ SSP demand partners.
 * We just provide zone names that match the data-fuse attribute and reserve
 * height to prevent CLS while ads load.
 */

// Map our internal unit names to Publift Fuse zone names
export const AD_UNITS = {
  'header-banner': {
    zone: 'pupvote-header-banner',
    sizes: {
      desktop: [[728, 90], [970, 90]],
      tablet: [[468, 60]],
      mobile: [[320, 50]],
    },
  },
  'grid-card': {
    zone: 'pupvote-grid-card',
    sizes: {
      desktop: [[300, 250]],
      mobile: [[300, 250], [250, 250]],
    },
  },
  sidebar: {
    zone: 'pupvote-sidebar',
    sizes: {
      desktop: [[300, 250], [300, 600], [160, 600]],
      mobile: [],
    },
  },
  'in-content': {
    zone: 'pupvote-in-content',
    sizes: {
      desktop: [[728, 90], [300, 250]],
      mobile: [[300, 250]],
    },
  },
};

/**
 * GAM ad unit path for the rewarded video slot. The slot lives directly in
 * our GAM network (not under Publift's Fuse) — Fuse handles display ad
 * monetization, but rewarded video uses a different demand pool and ships
 * direct via AdSense + AdX backfill.
 *
 * Confirm this path with the GAM ad unit setup in Phase 0 before flipping
 * the feature flag.
 */
export const REWARDED_AD_UNIT_PATH = '/21870650930/pupvote-rewarded-video';

/**
 * Get the largest size for an ad unit at the current viewport.
 * Used to reserve container height and prevent layout shift.
 */
export function getLargestSize(unitName, isDesktop) {
  const unit = AD_UNITS[unitName];
  if (!unit) return [0, 0];
  const sizes = isDesktop ? unit.sizes.desktop : unit.sizes.mobile;
  if (!sizes || sizes.length === 0) return [0, 0];
  // Find largest by area
  return sizes.reduce((largest, current) => {
    const largestArea = largest[0] * largest[1];
    const currentArea = current[0] * current[1];
    return currentArea > largestArea ? current : largest;
  });
}
